import React, { useEffect } from 'react';
import Hero from './Hero';
import About from './About';
import Services from './Services';
import FeaturedProperties from './FeaturedProperties';
import Contact from './Contact';

const POSTER = '/LandingPageAssets/Movies/Intro-poster.webp';

const HomePage = () => {
  // Precarga del póster solo en la home (se guarda en el HTML prerenderizado de "/").
  useEffect(() => {
    if (document.head.querySelector(`link[rel="preload"][href="${POSTER}"]`)) return;
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = POSTER;
    link.setAttribute('fetchpriority', 'high');
    document.head.appendChild(link);
  }, []);

  // Si la URL trae un ancla (p. ej. /#contact, venga de otra página o de un enlace
  // externo), baja a esa sección una vez que React ha pintado la página.
  useEffect(() => {
    const id = decodeURIComponent(window.location.hash.slice(1));
    if (!id) return undefined;
    const timer = setTimeout(() => {
      const target = document.getElementById(id);
      if (target) target.scrollIntoView({ behavior: 'instant', block: 'start' });
    }, 150);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Hero />
      <About />
      <Services />
      <FeaturedProperties />
      <Contact />
    </>
  );
};

export default HomePage;
